export const isShowQuestionDialog = ()=>{
    return window.location.hash === '#questionnaire'
}
